import { Button, Grid, Modal, Icon, CircularProgress, Tooltip } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';
import ColoredFormattedNumberForeign from 'components/ColoredFormattedNumberForeign';
import ModalActions from 'components/ModalActions';
import { theme } from 'components/Theme';
import { constants, FINANCIAL_BLOCK_TOOLTIP_MESSAGE } from 'helpers/constants';
import React, { Component } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { bankTransfer as bankTransferAction } from 'store/Orbita/Financial/actions';
import { listAccounts as listAccountsAction } from 'store/Orbita/Profile/actions';
import WithBetaModules from 'v2/components/Shared/WithBetaModules';

import AccountList from './components/AccountList';
import styles from './styles';

import type { DispatchProp } from 'react-redux';

const MIN_VALUE_TO_TRANSFER_DOLAR = 1000;
const MIN_VALUE_TO_TRANSFER_REAL = 5500;

interface IProps extends DispatchProp<any>, StyledComponentProps {
  value: any;
  selfClose: any;
  successCallback: any;
  open: boolean;
  onCloseModalTransfer: any;

  loadAvailable: any;
  bankTransfer: any;
  bankTransferAction: any;
  accounts: any;
  listAccountsAction: any;
  crossborder: boolean;
}

interface IState {
  checkedAvailable: boolean;
  valueAccount: any;
  valueTransfer: any;
  invoiceTable: boolean;
  modalTransfers: boolean;
  changeAccountList: boolean;
  accountActive: any;
  disableTransfer: boolean;
}

class TransferForeign extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      valueAccount: 0,
      valueTransfer: 0,
      modalTransfers: false,
      checkedAvailable: true,
      invoiceTable: false,
      changeAccountList: false,
      accountActive: {},
      disableTransfer: false,
    };
    this.handleOnClick = this.handleOnClick.bind(this);
    this.onOpenModalTransfers = this.onOpenModalTransfers.bind(this);
  }

  // ao clicar para transferir
  handleClickTransfers = (value: number) => {
    let valueTransfer = value;
    let account = this.props.accounts.length ? this.state.accountActive.id : null;
    this.setState({ modalTransfers: false });
    let status = {
      success: true,
    };
    if (!account) {
      status.success = false;
      toast.error('Por favor cadastre uma conta bancária.');
    }
    if (valueTransfer < 0) {
      status.success = false;
      toast.error('Valor inválido para transferência.');
    }
    if (valueTransfer < 100) {
      status.success = false;
      toast.error('O valor da transferência não pode ser menor que US$ 100,00.');
    }
    if (status.success) {
      (async () => {
        try {
          if (valueTransfer > 0) {
            this.setState({ disableTransfer: true });
            //TODO Tem que passar o Array de invoices conforme o component Transction
            await this.props.bankTransferAction(valueTransfer, account, []);
            this.setState({ disableTransfer: false });
          }
          if (this.props.successCallback) {
            this.props.successCallback(true);
          }
          toast.success('Sucesso, transferência realizada com êxito');
          if (this.props.successCallback) {
            this.props.successCallback(false);
          }
          this.props.selfClose();
        } catch (err) {
          toast.error('Ops, erro na transferência');
        }
      })();
    }
  };

  onOpenModalTransfers = (value: number) => {
    this.setState({ modalTransfers: true, valueTransfer: value });
  };

  handleOnClick() {
    this.onOpenModalTransfers(this.props.value);
  }

  onCancelModalTransfers = () => {
    this.setState({ modalTransfers: false });
  };

  componentDidMount() {
    const { crossborder } = this.props;
    const MinAbleToTransfer = crossborder ? MIN_VALUE_TO_TRANSFER_DOLAR : MIN_VALUE_TO_TRANSFER_REAL;
    if (this.props.value < MinAbleToTransfer) {
      this.setState({ disableTransfer: true });
    }
    (async () => {
      await this.props.listAccountsAction('active');
      const account = this.props.accounts[0];
      this.setState({
        accountActive: account,
      });
    })();
  }

  handleChangeAccount = (account: any) => {
    this.setState({
      accountActive: account,
    });

    this.toggleChangeAccount();
  };

  toggleChangeAccount = () => {
    this.setState({
      changeAccountList: !this.state.changeAccountList,
    });
  };

  render() {
    const { classes, value, crossborder } = this.props;
    const listAccounts = this.props.accounts;
    const currency = crossborder ? 'USD' : 'BRL';
    const MinAbleToTransfer = crossborder ? MIN_VALUE_TO_TRANSFER_DOLAR : MIN_VALUE_TO_TRANSFER_REAL;

    const renderTooltipValue = () => {
      if (value < MinAbleToTransfer) {
        return (
          <p>
            Valor mínimo para transferir: <FormattedNumber value={MinAbleToTransfer} format={currency}></FormattedNumber>
          </p>
        );
      }

      return '';
    };

    return (
      <React.Fragment>
        <MuiThemeProvider theme={theme}>
          <Modal
            open={this.props.open}
            onClose={this.props.onCloseModalTransfer}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                maxHeight: '90vh',
                overflow: 'auto',
                borderRadius: 4,
              }}
              className={classes.paper + (this.state.changeAccountList ? ' modal__transaction --flip' : ' modal__transaction')}
            >
              <div
                onClick={this.props.onCloseModalTransfer}
                className='transaction__exit'
                style={{ position: 'absolute', right: '24px', top: '24px', cursor: 'pointer' }}
              >
                <Icon>close</Icon>
              </div>
              {!this.state.changeAccountList && (
                <React.Fragment>
                  <Grid container spacing={0} className='transacation-list__accounts'>
                    <Grid item>
                      <div className='my-title' style={{ paddingRight: 8 }}>
                        <h2>Transferência bancária</h2>
                      </div>
                    </Grid>
                    <div className={classes.contentAmount}>
                      <div className={classes.rowAmount}>
                        <div className={'amount__checkbox'}>
                          <span className='label' style={{ margin: 30 }}>
                            Valor a transferir:
                          </span>
                        </div>
                        <div className={'amount__value'}>
                          <ColoredFormattedNumberForeign value={value} format={currency} />
                        </div>
                      </div>
                    </div>
                    <div className={classes.bank}>
                      {listAccounts && !listAccounts.isFetching && listAccounts.length > 0 && (
                        <div>
                          Transferir para Banco: <span>{this.state.accountActive.bank_id}</span>, Ag:{' '}
                          <span>
                            {this.state.accountActive.agency}-{this.state.accountActive.agency_digit}
                          </span>
                          , Conta:{' '}
                          <span>
                            {this.state.accountActive.account}-{this.state.accountActive.account_digit}
                          </span>
                          .
                          <p
                            onClick={this.toggleChangeAccount}
                            style={{
                              cursor: 'pointer',
                              color: '#3f51b5',
                              fontSize: '14px',
                              lineHeight: '14px',
                              marginTop: 5,
                              marginBottom: 0,
                            }}
                          >
                            Clique aqui para alterar a conta
                          </p>
                        </div>
                      )}
                      {listAccounts && listAccounts.isFetching && (
                        <div style={{ width: '100%', textAlign: 'center' }}>
                          <CircularProgress size={22} />
                        </div>
                      )}
                      {listAccounts && !listAccounts.isFetching && listAccounts.length === 0 && <div>Nenhuma conta bancária está ativa.</div>}
                    </div>
                    <div className='m16'></div>
                    {/* <Grid item>
                      <p>
                        O serviço de Transferência para Cross Border está temporariamente indisponível. Caso deseje realizar uma transferência entre
                        em contato com o nosso suporte.
                      </p>
                    </Grid> */}

                    <div className='m16'></div>
                    {/* <Grid container justify='flex-end' alignItems='center'>
                      <Grid item>
                        <Button color='primary' variant='contained' onClick={this.props.onCloseModalTransfer}>
                          Entendi
                        </Button>
                      </Grid>
                    </Grid> */}
                    <WithBetaModules>
                      {(betaModules: string[]) => {
                        const userHasBlockTransferBetaModule = betaModules?.includes('block_transfer');
                        const renderTooltipBlockTransfer = userHasBlockTransferBetaModule ? FINANCIAL_BLOCK_TOOLTIP_MESSAGE : false;
                        return (
                          <Tooltip title={renderTooltipBlockTransfer || renderTooltipValue()} placement='top'>
                            <div style={{ width: '100%' }}>
                              <Button
                                color='primary'
                                variant='contained'
                                className={classes.button}
                                style={{ width: '100%' }}
                                onClick={this.handleOnClick}
                                disabled={this.state.disableTransfer || userHasBlockTransferBetaModule}
                              >
                                Transferir
                                {this.props.bankTransfer && this.props.bankTransfer.isFetching && (
                                  <CircularProgress size={20} style={{ color: '#596375', marginLeft: 10 }} />
                                )}
                              </Button>
                            </div>
                          </Tooltip>
                        );
                      }}
                    </WithBetaModules>
                  </Grid>
                </React.Fragment>
              )}

              {this.state.changeAccountList && (
                <AccountList
                  handleChangeAccount={this.handleChangeAccount}
                  accountDefault={this.state.accountActive}
                  toggleChangeAccount={this.toggleChangeAccount}
                />
              )}
            </div>
          </Modal>

          <ModalActions
            open={this.state.modalTransfers}
            onClose={this.onCancelModalTransfers}
            onOk={() => this.handleClickTransfers(this.props.value)}
            title={'Atenção'}
            buttonOk={'Continuar'}
            //loading={updateCustomerById && updateCustomerById.isFetching}
            loadingColor='#ccc'
          >
            <p>
              Você solicitou uma transferência.
              <br />
              Neste valor será descontado os encargos de transferência no valor de{' '}
              <ColoredFormattedNumberForeign value={constants.TRANSFER_RATE_VALUE} format={currency} />. Então o valor total transferido para sua
              conta será de
              <b>
                <ColoredFormattedNumberForeign value={value - constants.TRANSFER_RATE_VALUE} format={currency} />
              </b>
              .
              <br />
              Deseja continuar com a transação?
            </p>
          </ModalActions>
        </MuiThemeProvider>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    accounts: state.orbita.Profile.accounts,
    loadAvailable: state.orbita.Financial.loadAvailable,
    bankTransfer: state.orbita.Financial.bankTransfer,
    crossborder: state.orbita.User.user.user.crossborder || false,
  };
};

export default connect(mapStateToProps, { listAccountsAction, bankTransferAction })(styles(TransferForeign));
